<template>
  <div class="layout-padding">
    <q-tabs ref="tabs" v-model="selectedTab" color="white" underline-color="primary" class="settings-tabs round-borders no-scroll">
      <q-tab name="general" slot="title" default :label="$t('general')" color="black"/>
      <q-tab name="contact-data" slot="title" :label="$t('contact_data')" color="black"/>
      <q-tab name="invoicing" slot="title" :label="$t('invoicing')" color="black"/>
      <q-tab name="payments" slot="title" :label="$tc('payment', 2)" color="black"/>
      <q-tab name="customers" slot="title" :label="$t('customers')" color="black"/>
      <q-tab name="members" slot="title" :label="$tc('member', 2)" color="black"/>
      <q-tab name="tax-advisor" slot="title" :label="$t('tax_advisor')" color="black"/>
      <q-tab name="subscription" slot="title" :label="$t('subscription')" color="black"/>
      <q-tab name="danger-zone" slot="title" :label="$t('danger_zone')" color="black" v-if="user.isOwnerOf(team)"/>

      <general-settings></general-settings>
      <contact-data></contact-data>
      <invoice-settings></invoice-settings>
      <payment-settings></payment-settings>
      <customer-settings></customer-settings>
      <member-settings></member-settings>
      <tax-advisor-settings></tax-advisor-settings>
      <subscription-settings></subscription-settings>
      <danger-zone-settings></danger-zone-settings>
    </q-tabs>
  </div>
</template>

<script>
  import ContactData from 'components/Team/Settings/Tabs/ContactData.vue'
  import CustomerSettings from 'components/Team/Settings/Tabs/CustomerSettings.vue'
  import DangerZoneSettings from 'components/Team/Settings/Tabs/DangerZone.vue'
  import GeneralSettings from 'components/Team/Settings/Tabs/GeneralSettings.vue'
  import InvoiceSettings from 'components/Team/Settings/Tabs/InvoiceSettings.vue'
  import MemberSettings from 'components/Team/Settings/Tabs/MemberSettings.vue'
  import PaymentSettings from 'components/Team/Settings/Tabs/PaymentSettings.vue'
  import SubscriptionSettings from 'components/Team/Settings/Tabs/SubscriptionSettings.vue'
  import TaxAdvisorSettings from 'components/Team/Settings/Tabs/TaxAdvisorSettings.vue'
  import { mapGetters } from 'vuex'
  import store from 'src/store'

  const TABS = [
    'subscription'
  ]

  export default {
    data () {
      return {
        selectedTab: 'general'
      }
    },

    computed: {
      ...mapGetters(['user', 'team', 'activeTeam'])
    },

    beforeRouteEnter (to, from, next) {
      store.dispatch('selectTeam', { teamId: parseInt(to.params.teamId) })
        .then(() => {
          next(vm => {
            if (to.query.hasOwnProperty('tab') && TABS.includes(to.query.tab)) {
              vm.selectedTab = to.query.tab
            }
          })
        })
    },

    components: {
      ContactData,
      CustomerSettings,
      DangerZoneSettings,
      GeneralSettings,
      InvoiceSettings,
      MemberSettings,
      PaymentSettings,
      SubscriptionSettings,
      TaxAdvisorSettings
    }
  }
</script>
